import integerWithCommas from '../../../shared/utils/integerWithCommas';
import styles from '../report.module.scss';

export default function CoursesDetails({ product, isPayByUser }: any) {
  return (
    <div className="d-flex justify-content-between">
      <div className="d-block">
        <div className={`${styles.commonStyles}`}>Available</div>
        <div className={styles.valueStyles}>
          {isPayByUser ? (
            <span>&#8734;</span>
          ) : (
            integerWithCommas(product.quantityNotRedeemed)
          )}
        </div>
      </div>
      <div className="d-block">
        <div className={`${styles.commonStyles}`}>Enrolled</div>
        <div className={styles.valueStyles}>
          {integerWithCommas(product.quantityRedeemed)}
        </div>
      </div>
      <div className="d-block">
        <div className={`${styles.commonStyles}`}>Completed</div>
        <div className={styles.valueStyles}>
          {integerWithCommas(product.statusCounts.Completed)}
        </div>
      </div>
    </div>
  );
}
